import React, { FC } from 'react';

import { Accordion as Molecule } from '@components/Molecules';

export const Accordion: FC<any> = (data) => {
  return <Molecule data={data} />;
};
